import {ContentContainer} from '@coolcolduk/ui-mui';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PageHeader from '../../../components/PageHeader';
import {PrivateRouteProps} from '../../../config/routeType';
import DropdownModule from '../../../atoms/dropdownModule/DropdownModule';
import BondDropdownTopicWithFilter from '../../../bonds/bondDropdownTopicWithFilter/BondDropdownTopicWithFilter';
import DropdownSeedQuestionStatus from '../../../atoms/dropdownSeedQuestionStatus/DropdownSeedQuestionStatus';
import AdminSeedQuestionList from './AdminSeedQuestionList';
import useAdminSeedQuestionsPage from './useAdminSeedQuestionsPage';

export default function AdminSeedQuestionsPage(_props: PrivateRouteProps) {
  const {
    examModules,
    seedQuestions,
    moduleId,
    validatedTopic,
    status,
    availableTopics,
    modulesLoading,
    seedQuestionsLoading,
    filtersExpanded,
    setFiltersExpanded,
    pagination,
    totalItems,
    handleModuleChange,
    handleTopicChange,
    handleStatusChange,
    handleFetchSeedQuestions,
    handleSeedQuestionClick,
    handlePageChange,
  } = useAdminSeedQuestionsPage({defaultFiltersExpanded: true});

  return (
    <ContentContainer data-testid="admin-seed-questions-page">
      <PageHeader title="Seed Question Management" />

      <Accordion expanded={filtersExpanded} onChange={(_, isExpanded) => setFiltersExpanded(isExpanded)} sx={{mb: 3}}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{px: 2}}>
          <Typography variant="h6" sx={{color: '#1B263B'}}>
            Filters
            {seedQuestions.length > 0 && (
              <Typography component="span" variant="body2" sx={{ml: 1, color: '#666', fontWeight: 400}}>
                ({seedQuestions.length} {seedQuestions.length === 1 ? 'question' : 'questions'})
              </Typography>
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack spacing={2}>
            <DropdownModule
              examModules={examModules || []}
              moduleId={moduleId}
              onChange={handleModuleChange}
              disabled={modulesLoading}
              autoSelectFirst={true}
            />
            {moduleId && (
              <BondDropdownTopicWithFilter
                availableTopics={availableTopics || []}
                value={validatedTopic}
                onChange={handleTopicChange}
                allowAll
                disabled={modulesLoading || (availableTopics && availableTopics.length === 0)}
              />
            )}
            {moduleId && <DropdownSeedQuestionStatus status={status} onChange={handleStatusChange} allowAll />}
            <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
              <Button
                variant="contained"
                onClick={handleFetchSeedQuestions}
                disabled={seedQuestionsLoading || !moduleId}
                sx={{
                  bgcolor: '#1B263B',
                  '&:hover': {bgcolor: '#1B263B', opacity: 0.8},
                  height: '56px',
                  minWidth: 150,
                }}
              >
                {seedQuestionsLoading ? <CircularProgress size={20} color="inherit" /> : 'Fetch Seed Questions'}
              </Button>
            </Box>
          </Stack>
        </AccordionDetails>
      </Accordion>

      {moduleId && (
        <AdminSeedQuestionList
          seedQuestions={seedQuestions}
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          startIndex={pagination.startIndex}
          loading={seedQuestionsLoading}
          moduleId={moduleId}
          totalItems={totalItems}
          onSeedQuestionClick={handleSeedQuestionClick}
          onPageChange={handlePageChange}
        />
      )}
    </ContentContainer>
  );
}
